<template>
  <div class="c-fill" :style="styles">
    <slot/>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  const props = defineProps<{
    weight?: number | string,
  }>();

  const styles = computed(() => {
    const weight = props.weight ?? 1;
    return {
      flexGrow: weight,
      flexShrink: weight,
    };
  });
</script>

<style lang="scss">
  .c-fill {
    .c-flex-row > & {
      min-width: 5rem;
    }
  }
</style>
